import { render } from "./RadioSelect.vue?vue&type=template&id=220799f0"
import script from "./RadioSelect.vue?vue&type=script&lang=js"
export * from "./RadioSelect.vue?vue&type=script&lang=js"
script.render = render

export default script